import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import store from "./store";
import { Provider } from "react-redux";
import App from "./App";
import * as Sentry from "@sentry/react";
import ErrorFallback from "./components/ErrorFallback";
import { getAppVersion } from "./helper/helper";
import { Capacitor } from "@capacitor/core";

Sentry.init({
  dsn: "https://34c5aa6275ce90e347e5819748b98ed5@o4509005027803136.ingest.us.sentry.io/4509005229522944",
  tracesSampleRate: 1.0,
  environment: process.env.NODE_ENV || "development",
  tracePropagationTargets: ["localhost", /^https:\/\/crobo\.money\//],
  replaysSessionSampleRate: 0.1,
  showDialog: true,
  replaysOnErrorSampleRate: 1.0,
  release: `${Capacitor.getPlatform()}-${await getAppVersion() ? await getAppVersion() : "1.0.21"}`,
});

// Set user information for Sentry
const user = {
  id: localStorage.getItem('userId') || 'anonymous',
  phone: localStorage.getItem('phone') || 'anonymous',
};

Sentry.setUser(user);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
       <Provider store={store}>
        <Sentry.ErrorBoundary
          fallback={({ error, resetError }) => (
            <ErrorFallback error={error} resetError={resetError} />
          )}
          showDialog
        >
          <App />
        </Sentry.ErrorBoundary>
      </Provider>
  </React.StrictMode>
);

// Configure performance monitoring through web vitals
reportWebVitals((metric) => {
  if (metric) {
    Sentry.captureMessage("Web Vital", {
      level: "info",
      extra: {
        name: metric.name,
        value: metric.value,
        id: metric.id,
        delta: metric.delta,
        entries: metric.entries,
        navigationType: metric.navigationType,
      },
    });
  }
});
